// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__S7-xu","tab":"Tabs_tab__J4kdq"};